/*=================服务地址===================*/
// 本地环境
// export const  serviceUrl = "http://localhost:8300"
// export const  serviceWebUrl = "http://localhost:8301"

// 测试环境
// export const  serviceUrl = "http://39.101.177.240:8300"
// export const  serviceWebUrl = "http://39.101.177.240:8301"

// 生产环境
export const  serviceUrl = "https://www.hengyuejy.com"
export const  serviceWebUrl = "https://www.hengyuejy.com"


/*===========OSS配置===========*/
let OSS = require('ali-oss');
export let ossClient = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1',
    bucket: 'free-back'
})

